<template>
  <div>
    <v-row>
      <v-col cols="12" class="mt-2 d-flex align-center justify-space-between">
        <v-select
          dense
          label="Nivel"
          :items="listNivel"
          item-value="id"
          @change="getCurso"
          item-text="desc_nivel"
          v-model="id_nivel"
          style="max-width: 200px"
        ></v-select>
        
        <v-btn color="blue darken-1" text @click="openModalAndSendRequest"
          >Generar Horario</v-btn
        >
      </v-col>
    </v-row>

    <ComunDialogComp v-model="dialog"  max-width="300" @close-modal="dialog = false" title="Generando horario">
      <template v-slot:body>
        <v-card>    
          <v-card-text class="text-center">
            <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
            size="50"
            ></v-progress-circular>

            <!-- Mensajes o notificaciones -->
            <ul v-if="messages.length">
            <li v-for="(msg, index) in messages" :key="index">{{ msg }}</li>
          </ul>

          <!-- Mostrar mensaje cuando no hay horarios generados -->
          <p v-if="!loading && !messages.length && !responseMessage">No se pudo generar ningún horario.</p>
          
          <!-- Mostrar el mensaje final del backend -->
          <p v-if="!loading && responseMessage">{{ responseMessage }}</p>
        </v-card-text>
        
        <v-card-actions v-if="!loading">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeModal">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
        </template>
    </ComunDialogComp>
    <v-row>
      <v-col>
        <v-expand-transition>
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              Cursos
              <v-btn
                icon
                :aria-expanded="showCursos.toString()"
                @click="toggleVisibility('cursos')"
              >
                <v-icon>{{
                  showCursos ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-col>
      <v-col>
        <v-expand-transition>
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              Docentes
              <v-btn
                icon
                :aria-expanded="showClases.toString()"
                @click="toggleVisibility('clases')"
              >
                <v-icon>{{
                  showClases ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-col>
      <v-col>
        <v-expand-transition>
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              Clases
              <v-btn
                icon
                :aria-expanded="showDocentes.toString()"
                @click="toggleVisibility('docentes')"
              >
                <v-icon>{{
                  showDocentes ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expand-transition>
          <v-card v-if="showCursos">
            <v-card-text>
              <Cursos
                :id_nivel="id_nivel"
                :horasSemanales ="horasSemanales"
                :cursosActualizados="cursosActualizados"
                @datosGuardados="handleDatosGuardados"
              ></Cursos>
            </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-expand-transition>
          <v-card v-if="showClases">
            <v-card-text>
              <Clases
                :id_nivel="id_nivel"
                :cursosActualizados="cursosActualizados"
                :todosLosHorarios = "todosLosHorarios"
              ></Clases>
            </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-expand-transition>
          <v-card v-if="showDocentes">
            <v-card-text>
              <Docentes
                :id_nivel="id_nivel"
                :id_nivel_act="id_nivel_act"
                :cursosActualizados="cursosActualizados"
              ></Docentes>
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "../../../helpers/axios";
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import Docentes from "./components/Docentes";
import Clases from "./components/Clases";
import Cursos from "./components/Cursos";

export default {
  name: "generarHorario",
  components: {
    ComunDialogComp,
    Docentes,
    Clases,
    Cursos,
  },
  data: () => ({
    id_nivel: "",
    id_nivel_act: "",
    listNivel: [],
    showCursos: false,
    showClases: false,
    showDocentes: false,
    id_colegio: sessionStorage.id_colegio,
    id_ano_lectivo: sessionStorage.id_ano_lectivo,
    cursos: [],
    datosCursos: [], //
    cursosActualizados: [],
    //datos para el calculo de las horas
    horariosAcademicos: [],
    horasDisponibles: [],
    duracionMinutos: "",
    primeraHora: "",
    horaEntrada: "",
    horaSalida: "",
    horaInicioRecreo: "",
    duracionRecreo: "",
    horaInicioRecreo2: "",
    nombre_recreo: "",
    nombre_recreo2: "",
    horasTotalDisponible: [],
    todosLosHorarios: [],
    horariosDeClase: [],
    //modal para generar horario
    dialog: false, 
    loading: false, 
    messages: [], 
    responseMessage: '' ,
    horarioAsignacionDetalles:[],
    cantidadDiasSeleccionados : 0,
    horasDiarias: 0,
    horasSemanales: 0
  }),
  mounted() {
    this.GetNivel();
  },
  methods: {
    resetFields() {
      this.id_nivel = "";
      this.id_grado = null;
    },

  
    async GetNivel() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
          filter: params,
        });

        this.listNivel = response.data;
        this.listNivel.sort((a, b) => a.desc_nivel.localeCompare(b.desc_nivel));
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    // estos son los cursos por niveles
    async getCurso() {
      this.getHorarioAcademico();
      let parametros = {
        id_colegio: this.id_colegio,
        id_nivel: this.id_nivel,
        id_ano_lectivo: this.id_ano_lectivo,
      };


      try {
        const response = await axios.post(
          `/horario/horarioAutomatico`,
          parametros
        );
        this.cursos = response.data;
        const responseDatosCursos = await axios.get(
          `horario/horarioCurso/cursos/${this.id_colegio}/${this.id_ano_lectivo}`
        );
        this.datosCursos = responseDatosCursos.data;

        this.id_nivel_act = this.cursos[0].id_nivel;

        this.cursosActualizados = this.cursos.map((curso) => {
          const cursoModificado = this.datosCursos.find(
            (dato) =>
              dato.id_colegio === curso.id_colegio &&
              dato.id  === curso.id
          );

          if (cursoModificado) {
            const resultado = { ...curso, ...cursoModificado, id_area: curso.id };
            return resultado;
          } else {
            return curso;
          }
        });
        return this.cursosActualizados;
      } catch (error) {
        console.error("Error en getCurso:", error);
      }
    },
    handleDatosGuardados() {
      this.getCurso();
    },

    toggleVisibility(card) {
      this.showCursos = card === "cursos" ? !this.showCursos : false;
      this.showClases = card === "clases" ? !this.showClases : false;
      this.showDocentes = card === "docentes" ? !this.showDocentes : false;
    },

    async getHorarioAcademico() {
      try {
        let response = await axios.get(
          `/administrativo/horarioAcademico/${this.id_colegio}/${this.id_nivel}/`
        );
        this.horariosAcademicos = response.data.data;

        this.horariosAcademicos.forEach((horario, index) => {
          this.calcularHora(index);
        });
      } catch (error) {
        console.error("Error al obtener el horario académico:", error);
      }
    },

    calcularHora(index) {
      this.asignarVariablesHorario(index);
      let horario = this.horariosAcademicos[index];
      let horasDisponibles = [];

      let horaInicio = horario.hora_entrada.split(":").slice(0, 2).join(":");
      let horaFin = horario.hora_salida.split(":").slice(0, 2).join(":");
      let horaInicioRecreo = horario.inicio_recreo1
        .split(":")
        .slice(0, 2)
        .join(":");
      let horaInicioRecreo2 = horario.inicio_recreo2
        .split(":")
        .slice(0, 2)
        .join(":");

      let primeraHora = parseInt(horario.hora_de_formacion.split(":")[1]);
      // eslint-disable-next-line no-unused-vars
      let duracionMinutos = parseInt(horario.duracion_hora_academica);

      // Tratamiento de la primera hora de formación
      if (primeraHora !== null && !isNaN(primeraHora)) {
        const horasPrimera = Math.floor(primeraHora / 60);
        const minutosPrimera = primeraHora % 60;
        let nuevaHoraInicio = new Date(
          2022,
          0,
          1,
          parseInt(horaInicio.split(":")[0]) + horasPrimera,
          parseInt(horaInicio.split(":")[1]) + minutosPrimera
        );
        let horaFinFormacion = `${nuevaHoraInicio
          .getHours()
          .toString()
          .padStart(2, "0")}:${nuevaHoraInicio
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;

        if (horaInicio !== horaFinFormacion) {
          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinFormacion}`,
            tipo: "Formación",
            horaInicio,
            horaFin: horaFinFormacion,
            id_turno: horario.id_turno,
          });
          horaInicio = horaFinFormacion;
        }
      }

      // Extraer horas, minutos y segundos de la duración
      let [horasDuracion, minutosDuracion, segundosDuracion] =
        this.duracionMinutos.split(":").map(Number);

      // Calcular la duración total en minutos
      let duracionTotalMinutos =
        horasDuracion * 60 + minutosDuracion + segundosDuracion / 60;

      while (horaInicio < horaFin) {
        let [hora, minuto] = horaInicio.split(":").map(Number);
        let inicio = new Date(2022, 0, 1, hora, minuto);

        // Manejo de los recreos
        if (horaInicio === horaInicioRecreo) {
          // Convertir el tiempo de recreo de formato "00:20:00" a minutos
          let [horas, minutos, segundos] = horario.tiempo_de_recreo
            .split(":")
            .map(Number);
          let tiempoRecreoEnMinutos = horas * 60 + minutos + segundos / 60;

          // Crear un objeto Date para la hora de inicio del recreo
          let inicioRecreo = new Date(
            2022,
            0,
            1,
            parseInt(horaInicio.split(":")[0]),
            parseInt(horaInicio.split(":")[1])
          );

          // Sumar el tiempo de recreo
          let finRecreo = new Date(
            inicioRecreo.getTime() + tiempoRecreoEnMinutos * 60000
          );

          let horaFinRecreo = `${finRecreo
            .getHours()
            .toString()
            .padStart(2, "0")}:${finRecreo
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo}`,
            tipo: this.nombre_recreo,
            horaInicio,
            horaFin: horaFinRecreo,
            id_turno: horario.id_turno,
          });

          // Actualizar horaInicio para la siguiente iteración
          horaInicio = horaFinRecreo;
          inicio = finRecreo;
        }

        if (horaInicio === horaInicioRecreo2) {
          // Convertir el tiempo de recreo2 de formato "00:20:00" a minutos
          let [horas, minutos, segundos] = horario.tiempo_de_recreo2
            .split(":")
            .map(Number);
          let tiempoRecreo2EnMinutos = horas * 60 + minutos + segundos / 60;

          // Crear un objeto Date para la hora de inicio del recreo2
          let inicioRecreo2 = new Date(
            2022,
            0,
            1,
            parseInt(horaInicio.split(":")[0]),
            parseInt(horaInicio.split(":")[1])
          );

          // Sumar el tiempo de recreo2
          let finRecreo2 = new Date(
            inicioRecreo2.getTime() + tiempoRecreo2EnMinutos * 60000
          );

          let horaFinRecreo2 = `${finRecreo2
            .getHours()
            .toString()
            .padStart(2, "0")}:${finRecreo2
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo2}`,
            tipo: this.nombre_recreo2,
            horaInicio,
            horaFin: horaFinRecreo2,
            id_turno: horario.id_turno,
          });

          horaInicio = horaFinRecreo2;
          inicio = finRecreo2;
        }

        let fin = new Date(inicio.getTime() + duracionTotalMinutos * 60000);
        let horasFin = fin.getHours().toString().padStart(2, "0");
        let minutosFin = fin.getMinutes().toString().padStart(2, "0");
        let nuevoInicio = `${horasFin}:${minutosFin}`;

        if (nuevoInicio > horaFin) break;

        horasDisponibles.push({
          hora: `${horaInicio} - ${nuevoInicio}`,
          tipo: "Clase",
          horaInicio,
          horaFin: nuevoInicio,
          id_turno: horario.id_turno,
        });
        horaInicio = nuevoInicio;
      }
      // Al final del método, en lugar de retornar horasDisponibles:
      this.todosLosHorarios = this.todosLosHorarios.concat(horasDisponibles);
      this.horasTotalDisponible[index] = horasDisponibles
        .filter((item) => item.tipo == "Clase")
        .map((item) => {
          return {
            disponible: false,
            hora: item.hora,
            tipo: item.tipo,
            horaInicio: item.horaInicio,
            horaFin: item.horaFin,
            id: item.id,
            id_turno: horario.id_turno,
          };
        });
          
        const clasesEnTurno = horasDisponibles.filter(item => item.tipo === "Clase" && item.id_turno === horario.id_turno);
        this.horasDiarias = clasesEnTurno.length;
       this.diasSelect();
    },

    //metodo para calculas las horas disponibles a asignar.

    async diasSelect() {
      let idColegio = parseInt(sessionStorage.getItem("id_colegio"));
      
      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${idColegio}`
        );
        
        const responseData = response.data[0];  
        const diasSeleccionados = responseData.dias_seleccionados;  
        this.cantidadDiasSeleccionados = diasSeleccionados.length;
     

        if (this.cantidadDiasSeleccionados > 0 && this.horasDiarias > 0) {
         this.horasSemanales = this.cantidadDiasSeleccionados * this.horasDiarias;
        
      } 
      
       
      } catch (e) {
        // eslint-disable-next-line no-undef
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // metodo de los checbox

    asignarVariablesHorario(index) {
      if (index >= this.horariosAcademicos.length) {
        return;
      }

      const horario = this.horariosAcademicos[index];
      this.duracionMinutos = horario.duracion_hora_academica;
      this.primeraHora = parseInt(horario.hora_de_formacion.split(":")[1]);
      this.horaEntrada = horario.hora_entrada;
      this.horaSalida = horario.hora_salida;
      this.horaInicioRecreo = horario.inicio_recreo1;
      this.duracionRecreo = parseInt(horario.tiempo_de_recreo.split(":")[1]);
      this.horaInicioRecreo2 = horario.inicio_recreo2;
      this.duracionRecreo2 = parseInt(horario.tiempo_de_recreo2.split(":")[1]);
      this.nombre_recreo = horario.titulo_recreo1;
      this.nombre_recreo2 = horario.titulo_recreo2;
    },


    async generarHorario() {
      const parametro = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
        id_nivel: this.id_nivel,
        todosLosHorarios: this.todosLosHorarios
      };

    try {
      const result = await axios.post(`horario/horarioAutomatico/generarHorario/`, parametro);

      if (!result.data.result[0].asignarhorariosmodular) {
        this.responseMessage = result.data.message || 'No se pudo asignar ningún horario.';
        this.horarioAsignacionDetalles = []; // No hay detalles de asignación
      } else {
        this.responseMessage = result.data.message || 'Horario generado correctamente.';
        this.horarioAsignacionDetalles = result.data.result[0].asignarhorariosmodular || [];
        this.$store.dispatch('actualizarHorarioDetalles', this.horarioAsignacionDetalles);
      }

    } catch (error) {
      this.responseMessage = 'Hubo un error al generar el horario.';
      this.horarioAsignacionDetalles = []; // No hay detalles si hay un error
    } finally {
      this.loading = false;
    }
},


  openModalAndSendRequest() {
    this.dialog = true;  
    this.loading = true;  
    this.responseMessage = ''; 
    this.generarHorario(); 
  },

    closeModal() {
      this.dialog = false;
      this.responseMessage = ""; 
    }
  },
};
</script>

<style></style>
